// extracted by mini-css-extract-plugin
export default {"header":"kG","discountBanner":"lG","logo":"mG","maincontainer":"nG","videocontainer":"oG","videowelcome":"pG","videowrapper":"qG","videosale":"rG","loadingcontainer":"sG","footer":"tG","footerbutton":"uG","video":"vG","logoname":"wG"};
    if(module.hot) {
      // 1713996747661
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  